export const environment = {
  production: false,
  //apiBaseUrl: '/api',
  domainCookie: 'iconstruye.cl',
  urlApiSSO: 'https://qa-api-login.azurewebsites.net',
  apiBaseUrl: 'https://qa-api-gateway.iconstruye.cl/panelcompras',
};
